import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sidebar.size < 2)?_c(VAppBar,{staticClass:"header",attrs:{"data-id":"header-toolbar","app":"","flat":"","color":"white"}},[_c(VToolbarTitle,[_vm._v(_vm._s(_vm.title))]),_c(VSpacer),_vm._t("default"),(_vm.actions.length)?_c('ActionButtons',{attrs:{"actions":_vm.actions}}):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }